<template>
    <div class="order">
        <div class="luck-btn flex_between"> 
            <div class="flex" style="align-items: center;">
                <p>收入利润表-</p>
                <p style="color:#409EFF;">截止{{endDate}}</p>
            </div>
            <div><span>单位：辆/元</span></div>
            
        </div>
        <div id="luckysheet" v-loading="loading" ref="scrollview"
        @mousewheel="scrollChange"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)">
        
        </div>
    </div>
</template>
<script>
import { carTypeIndex,carTypeItem,firstHeader,indexOne, saleHeader,border } from '@/assets/js/lr'
// import { getIndexArrOne,getRC,getIndexArrMonth} from '@/util/getTableData';
export default {
    props:{
        data:{
            type:Object,
            default:{}
        },
        sdate:{
            type:String,
            default:''
        },
        edate:{
            type:String,
            default:''
        },
        carType:{
            type:Array,
            default:[]
        }
    },
    data(){
        return{
            edited:[],
            canEdit:[],
            tableLength:0,
            tableData:this.data,
            date:[],
            endDate:'',
            mydata:[],
            loading:false,
            options: {},
            
        }
    },
    mounted(){
        let _this = this
        this.options = {
                container: 'luckysheet', //容器id名
                title: '收入利润表', // 表 头名
                lang: 'zh', // 中文
                showtoolbar: false, // 是否显示工具栏
                showinfobar: false, // 是否显示顶部信息栏
                showsheetbar:false,
                // showstatisticBar:false,
                enableAddRow:false,
                sheetFormulaBar:false,
                enableAddRow:false,
                enableAddBackTop:false,
                accuracy:0,
                cellRightClickConfig:{
                    
                    copy: false, // 复制
                    copyAs: false, // 复制为
                    paste: false, // 粘贴
                    insertRow: false, // 插入行
                    insertColumn: false, // 插入列
                    deleteRow: false, // 删除选中行
                    deleteColumn: false, // 删除选中列
                    deleteCell: false, // 删除单元格
                    hideRow: true, // 隐藏选中行和显示选中行
                    hideColumn: true, // 隐藏选中列和显示选中列
                    rowHeight: false, // 行高
                    columnWidth: false, // 列宽
                    clear: false, // 清除内容
                    matrix: false, // 矩阵操作选区
                    sort: false, // 排序选区
                    filter: false, // 筛选选区
                    chart: false, // 图表生成
                    image: false, // 插入图片
                    link: false, // 插入链接
                    data: false, // 数据验证
	                cellFormat: false // 设置单元格格式
                },
                hook: {
                    cellUpdated: function (r, c, oldValue, newValue, isRefresh) {
                        if(isRefresh){
                            if(_this.edited.length>0){
                                const has = _this.edited.filter(item=>item.r==r&&item.c==c)
                                if(has.length>0){
                                    _this.edited.forEach(item=>{
                                        if(item.r==r&&item.c==c){
                                            item.v = newValue.v
                                        }
                                    })
                                }else{
                                    _this.edited.push({r:r,c:c,v:newValue.v})
                                }
                            }else{
                                _this.edited.push({r:r,c:c,v:newValue.v})
                            }
                            _this.edited.forEach(item=>{
                                item.name = window.luckysheet.getCellValue(item.r,3)
                                item.date = window.luckysheet.getCellValue(0,item.c)
                            })
                            _this.$emit('getEditData',_this.edited)
                            window.luckysheet.exitEditMode()
                           
                        }
                    }
                }
                
            }
        let arr = this.edate.split("-")
        this.endDate = arr[0]+'年'+arr[1]+'月'
        this.tableLength = 12+(this.carType.length*12)
        window.luckysheet.exitEditMode();
        window.luckysheet.destroy();
        this.getExcelDate()
        const scrollview = this.$refs['scrollview']
        scrollview.addEventListener('scroll', this.scrollChange, true)
    },
    methods:{
        scrollChange () {
            window.luckysheet.exitEditMode()
        },

        // 计算年月
        getExcelDate(){
            let sy= Number(this.sdate.split("-")[0]);
            let ey= Number(this.edate.split("-")[0]);
            let sm = Number(this.sdate.split("-")[1]);
            let em = Number(this.edate.split("-")[1]);

            let y ;
            let date = []
            if(sy==ey){//同一年
                if(em>sm){
                    for(let i=sm;i<=em;i++){
                        date.push(`${sy}年${i}月`)
                    }
                }else if(em==sm){
                    date.push(`${ey}年${em}月`)
                }else{
                    this.$DonMessage.error("结束日期必须在开始日期之后")
                }
            }else if(ey>sy){//不同年
                y = ey-sy
                if(y==1){// 没有间隔的一整年
                    for(let i=sm;i<=12;i++){
                        date.push(`${sy}年${i}月`)
                    }
                    for(let j=1;j<=em;j++){
                        date.push(`${ey}年${j}月`)
                    }
                }
                if(y>1){//中间有完整一整年
                    let fwy = sy+1
                    let lwy = ey-1
                    for(let i=sm;i<=12;i++){
                        date.push(`${sy}年${i}月`)
                    }
                    for(let year=fwy;year<=lwy;year++){
                        for(let month=1;month<=12;month++){
                            date.push(`${year}年${month}月`)
                        } 
                    }
                    for(let j=1;j<=em;j++){
                        date.push(`${ey}年${j}月`)
                    }
                }

            }else{
                this.$DonMessage.error("结束日期必须在开始日期之后")
            }
            this.date = date
            this.handleTest()
        },
        demo(){
            if(this.mydata[0].celldata.length>0){
                window.luckysheet.destroy();
                this.options.data = this.mydata;
                window.luckysheet.create(this.options);
                this.$store.state.excelLoading = false
                // window.luckysheet.setDataVerification(
                //     {
                //         type: 'number_integer',
                //         type2: "bw",
                //         value1: 0,
                //         value2: 99999,
                //         prohibitInput: true
                //     },
                //     {
                //         range: `E2:E${this.tableLength}`
                //     }
                // )
                window.luckysheet.setDataVerification(
                    {
                        type: 'number',
                        type2: "bw",
                        value1: '0.00',
                        value2: '1000000.00',
                        prohibitInput: true
                    },
                    {
                        range: `G8:EX8`
                    }
                )
                this.canEdit.map(item=>{
                    window.luckysheet.setDataVerification(
                        {
                            type: 'number',
                            type2: "bw",
                            value1: '0.00',
                            value2: '10000.00',
                            prohibitInput: true
                        },
                        {
                            range: `G${item+1}:EX${item+2}`
                        }
                    )
                })
                let bgArr = []
                bgArr.push(`C8:CX8`)
                this.canEdit.map(item=>{
                    bgArr.push(`C${item+1}:EX${item+2}`)
                })
              
                if(bgArr.length>0){
                    window.luckysheet.setRangeFormat("bg", '#E3F2D9', {range:[...bgArr]})
                }
             
                window.luckysheet.setRangeShow({ row:[0], column:[0] }, {
                    show: false, // 选中状态不要高亮
                })
            }
        },
        handleTest(){
            this.canEdit = []
            this.carType.map((item,i)=>{
                this.canEdit.push(20+12*i)
            })
           
            this.mydata = [
                {   
                    name: "这个是sheet1",
                    celldata: [],
                    frozen:{
                       type: 'rangeBoth',
                       range: {row_focus: 0, column_focus: 3}
                    },
                   
                    config: {
                        authority:{// 当前工作表的权限配置
                            sheet: 1, // sheet表下标。
                            hintText: "这部分不可以进行修改", // 弹

                            allowRangeList: [
                                // { sqref: `$E$2:$E$${this.tableLength}` },//期初数
                            	{ sqref: `$G$8:$EX$8` },//设置A2~D6为可编辑区域，其它区域不可编辑
                                // { sqref: '$E$21:$X$22' },
                               
                                // { sqref: '$E$33:$X$34' },
                                // { sqref: '$E$34:$X$23' },
                            ],
                        },
                        borderInfo: [...border],
                    },
                    
                    
                    
                },
            ];
            this.canEdit.map(item=>{
                this.mydata[0].config.authority.allowRangeList.push(
                    { sqref: `$G$${item+1}:$EX$${item+2}` }
                )
            })
            
    
            // 表头数据项
            firstHeader.map((item,index)=>{
                this.mydata[0].celldata.push(
                    {
                        r:0,
                        c:index,
                        v:{
                            bg:"#195c96",
                            bl: 1, 
                            v:item,
                            ht:0,
                            fc:'#fff'
                        },
                        
                    }
                )
            })
            // 年月数据
            if(this.date.length>0){
                this.date.map((item,index)=>{
                    this.mydata[0].celldata.push(
                        {
                            r:0,
                            c:index+6,
                            v:{
                                bg:"#195c96",
                                bl: 1, 
                                v:item,
                                ht:0,
                                fc:'#fff'
                            },

                        }
                    )
                })

            }
            // 添加序号数据项
            indexOne.map((item,index)=>{
                this.mydata[0].celldata.push(
                    {
                        r:index+1,
                        c:2,
                        v:{
                            v:item,
                            ht:0
                        }
                    }
                )
            })
            // 添加销量项目名
            saleHeader.map((item,index)=>{
                this.mydata[0].celldata.push(
                    {
                        r:index+1,
                        c:3,
                        v:{
                            v:item,
                            ht:0
                        }
                    }
                )
            })
           // 根据车型动态添加相关序号和项目名称以及合并项
            // 合并项：合计、车型、 /
            let mc = [
                {
                    "r": 1,
                    "c": 0,
                    "v": {
                        "v":'/',
                        "bl": 1, 
                        'ht':0,
                    },
                    "mc": {      
                        "r": 1,  
                        "c": 0,  
                        "rs": 11, 
                        "cs": 1  
                    },

                }, 
                {
                    "r": 1,
                    "c": 1,
                    "v": {
                        "v":'合计',
                        "bl": 1, 
                        'ht':0,
                    },
                    "mc": {      
                        "r": 1,  
                        "c": 1,  
                        "rs": 11, 
                        "cs": 1  
                    },

                }, 
            ]
            let merge = {
                "1_0": {
                    "r": 1,
                    "c": 0,
                    "rs": 11,
                    "cs": 1
                },
                "1_1": {
                    "r": 1,
                    "c": 1,
                    "rs": 11,
                    "cs": 1
                },
            }
            let brr = []//车型项目名
            let crr = []//车型序号
            let borderArr = []//边框数据
            borderArr.push({
                    "rangeType": "range",
                    "borderType": "border-all",
                    "style": "3",
                    "color": "#a4a4a4",
                    "range": [{
                        "row": [0, saleHeader.length+(this.carType.length*12)],
                        "column": [0, firstHeader.length+this.date.length-1]
                    }]
                },)
            this.carType.map((item,i)=>{
                brr.push(...carTypeItem)
                crr.push(...carTypeIndex)
                mc.push({
                    "r": saleHeader.length+1+(i*12),
                    "c": 0,
                    "v": {
                        "v":item.carModelName,
                        'ht':0,
                    },
                    "mc": {       
                        "r": saleHeader.length+1+(i*12),   
                        "c": 0,   
                        "rs": 11, 
                        "cs": 1   
                    },
                },
                {
                    
                    "r": saleHeader.length+1+(i*12),
                    "c": 1,
                    "v": {
                        "v":'/',
                        'ht':0,
                    },
                    "mc": {       
                        "r": saleHeader.length+1+(i*12),   
                        "c": 1,   
                        "rs": 11, 
                        "cs": 1   
                    },

                
                })
                merge[`${saleHeader.length+1+(i*12)}_0`] = { 
                    "r": saleHeader.length+1+(i*12),
                    "c": 0,
                    "rs": 12,
                    "cs": 1
                 }
                 merge[`${saleHeader.length+1+(i*12)}_1`] = { 
                    "r": saleHeader.length+1+(i*12),
                    "c": 1,
                    "rs": 12,
                    "cs": 1
                 }
                 borderArr.push(
                    {
                    "rangeType": "range",
                    "borderType": "border-bottom",
                    "style": "8",
                    "color": "#77b8f9",
                    "range": [{
                        "row": [0, saleHeader.length+(i*12)],
                        "column": [0, firstHeader.length+this.date.length-1]
                    }]
                })

            })
            this.mydata[0].config.borderInfo = [...borderArr]
            // 车型合并项
            this.mydata[0].celldata.push(...mc)
            // 合并配置
            this.mydata[0].config.merge = merge
            brr.map((item,index)=>{
                this.mydata[0].celldata.push(
                    {
                        r:saleHeader.length+1+index,
                        c:3,
                        v:{ 
                            v:item,
                            ht:0
                        },
                    }
                )
            })
            crr.map((item,index)=>{
                    this.mydata[0].celldata.push(
                        {
                            r:saleHeader.length+1+index,
                            c:2,
                            v:{ 
                                v:item,
                                ht:0
                            },
                        }
                    )
            })
    
            this.fillPosition()
            // this.demo()
        },
        fillPosition(){
            let array = this.mydata[0].celldata
            array.map(a=>{
                this.tableData.incomeStatementEachCarModel.map(item=>{//单个车型
                    if(a.v.v==item.carModelName){
                        item.r = a.r
                    }
                    item.salesPlanCountResultList.map(b=>{//销售计划
                        if(a.v.v==this.getExcelData(b.eachMonthLocalDate)){
                            b.c = a.c
                        }
                    })
                    // 少个运营费及其他
                    // 单个添加 //销售单价(从次月开始)、 销售单价首月、收入合计、成本（次月首月）,物流费用次首月，关税次首月,成本合计
                    item.planCountResultList.map(b=>{//订单计划
                        if(a.v.v==this.getExcelData(b.eachMonthLocalDate)){
                            b.c = a.c
                        }
                    })

                })
                this.tableData.incomeStatementEachMonth.map(data=>{
                    if(a.v.v==this.getExcelData(data.month)){
                        data.c = a.c
                    }
                })
            })
            this.fillData()
        },
        fillData(){
            this.tableData.incomeStatementEachCarModel.map(item=>{
                item.salesPlanCountResultList.map(b=>{//销售计划
                        this.mydata[0].celldata.push(
                        {
                            r:item.r+1,
                            c:b.c,
                            v:{ 
                                v:b.salesPlanCount,
                                ht:0
                            },
                        }
                    )
                })
                item.planCountResultList.map(b=>{//订单计划
                        this.mydata[0].celldata.push(
                        {
                            r:item.r,
                            c:b.c,
                            v:{ 
                                v:b.orderPlanCount,
                                ht:0
                            },
                        }
                    )
                })
                item.totalRevenue.map((data,i)=>{//收入合计
                    this.mydata[0].celldata.push(
                        {
                            r:item.r+3,
                            c:i+6,
                            v:{ 
                                v:data,
                                ht:0
                            },
                        }
                    )
                })
                item.totalCostList.map((data,i)=>{//成本合计
                    this.mydata[0].celldata.push(
                        {
                            r:item.r+7,
                            c:i+6,
                            v:{ 
                                v:data,
                                ht:0
                            },
                        }
                    )
                })
                item.monthlySalesPriceChange.map((data,i)=>{//销售单价变动
                    this.mydata[0].celldata.push(
                        {
                            r:item.r+8,
                            c:i+6,
                            v:{ 
                                v:data,
                                ht:0
                            },
                        }
                    )
                })
                item.monthlyCostDataChange.map((data,i)=>{//成本变动
                    this.mydata[0].celldata.push(
                        {
                            r:item.r+9,
                            c:i+6,
                            v:{ 
                                v:data,
                                ht:0
                            },
                        }
                    )
                })
                item.profitList.map((data,i)=>{//利润
                    this.mydata[0].celldata.push(
                        {
                            r:item.r+10,
                            c:i+6,
                            v:{ 
                                v:data,
                                ht:0
                            },
                        }
                    )
                })
                item.profitMarginList.map((data,i)=>{//利润率
                    this.mydata[0].celldata.push(
                        {
                            r:item.r+11,
                            c:i+6,
                            v:{ 
                                v:data+'%',
                                ht:0
                            },
                        }
                    )
                })
                // -次月开始
                item.salesUnitPriceOtherMonthList.map((data,i)=>{//销售单价
                    this.mydata[0].celldata.push(
                        {
                            r:item.r+2,
                            c:i+7,
                            v:{ 
                                v:data,
                                ht:0
                            },
                        }
                    )
                })
                item.costOtherMonthList.map((data,i)=>{//成本
                    this.mydata[0].celldata.push(
                        {
                            r:item.r+4,
                            c:i+7,
                            v:{ 
                                v:data,
                                ht:0
                            },
                        }
                    )
                })
                item.logisticsExpensesOtherMonthList.map((data,i)=>{//物流
                    this.mydata[0].celldata.push(
                        {
                            r:item.r+5,
                            c:i+7,
                            v:{ 
                                v:data,
                                ht:0
                            },
                        }
                    )
                })
                item.tariffOtherMonthList.map((data,i)=>{//关税
                    this.mydata[0].celldata.push(
                        {
                            r:item.r+6,
                            c:i+7,
                            v:{ 
                                v:data,
                                ht:0
                            },
                        }
                    )
                })
                this.mydata[0].celldata.push(
                        {
                            r:item.r+0,
                            c:5,
                            v:{ 
                                v:item.planCountTotal,
                                ht:0
                            },
                        },
                        {
                            r:item.r+1,
                            c:5,
                            v:{ 
                                v:item.salesPlanCountTotal,
                                ht:0
                            },
                        },
                        {
                            r:item.r+2,
                            c:5,
                            v:{ 
                                v:item.salesUnitPriceTotal,
                                ht:0
                            },
                        },
                        {
                            r:item.r+3,
                            c:5,
                            v:{ 
                                v:item.totalRevenueTotal,
                                ht:0
                            },
                        },
                        {
                            r:item.r+4,
                            c:5,
                            v:{ 
                                v:item.costTotal,
                                ht:0
                            },
                        },
                        {
                            r:item.r+5,
                            c:5,
                            v:{ 
                                v:item.logisticsExpensesTotal,
                                ht:0
                            },
                        },
                        {
                            r:item.r+6,
                            c:5,
                            v:{ 
                                v:item.tariffTotal,
                                ht:0
                            },
                        },
                        {
                            r:item.r+7,
                            c:5,
                            v:{ 
                                v:item.totalCostTotal,
                                ht:0
                            },
                        },
                        {
                            r:item.r+8,
                            c:5,
                            v:{ 
                                v:item.monthlySalesPriceChangeTotal,
                                ht:0
                            },
                        },
                        {
                            r:item.r+9,
                            c:5,
                            v:{ 
                                v:item.monthlyCostDataChangeTotal,
                                ht:0
                            },
                        },
                        {
                            r:item.r+10,
                            c:5,
                            v:{ 
                                v:item.profitTotal,
                                ht:0
                            },
                        },
                        {
                            r:item.r+11,
                            c:5,
                            v:{ 
                                v:item.profitMarginTotal+'%',
                                ht:0
                            },
                        },
                        {
                            r:item.r+2,
                            c:6,
                            v:{ 
                                v:item.salesUnitPriceFirstMonth,
                                ht:0
                            },
                        },
                        {
                            r:item.r+4,
                            c:6,
                            v:{ 
                                v:item.costFirstMonth,
                                ht:0
                            },
                        },
                        {
                            r:item.r+5,
                            c:6,
                            v:{ 
                                v:item.logisticsExpensesFirstMonth,
                                ht:0
                            },
                        },
                        {
                            r:item.r+6,
                            c:6,
                            v:{ 
                                v:item.tariffFirstMonth,
                                ht:0
                            },
                        }
                )



            })
            this.tableData.incomeStatementEachMonth.map(item=>{
                this.mydata[0].celldata.push(
                    {
                        r:1,
                        c:item.c,
                        v:{ 
                            v:item.salesPlanCount,
                            ht:0
                        },
                    },
                    {
                        r:2,
                        c:item.c,
                        v:{ 
                            v:item.salesUnitPrice,
                            ht:0
                        },
                    },
                    {
                        r:3,
                        c:item.c,
                        v:{ 
                            v:item.totalRevenue,
                            ht:0
                        },
                    },
                    {
                        r:4,
                        c:item.c,
                        v:{ 
                            v:item.cost,
                            ht:0
                        },
                    },
                    {
                        r:5,
                        c:item.c,
                        v:{ 
                            v:item.logisticsExpenses,
                            ht:0
                        },
                    },
                    {
                        r:6,
                        c:item.c,
                        v:{ 
                            v:item.tariff,
                            ht:0
                        },
                    },
                    {
                        r:7,
                        c:item.c,
                        v:{ 
                            v:item.operatingExpensesAndOther,
                            ht:0
                        },
                    },
                    {
                        r:8,
                        c:item.c,
                        v:{ 
                            v:item.totalCost,
                            ht:0
                        },
                    },
                    {
                        r:9,
                        c:item.c,
                        v:{ 
                            v:item.monthlyDataChange,
                            ht:0
                        },
                    },
                    {
                        r:10,
                        c:item.c,
                        v:{ 
                            v:item.profit,
                            ht:0
                        },
                    },
                    {
                        r:11,
                        c:item.c,
                        v:{ 
                            v:item.profitMargin+'%',
                            ht:0
                        },
                    },
                )
            })
            let obj = this.tableData.orderPlanTotalColumn
            this.mydata[0].celldata.push(
                {
                    r:1,
                    c:5,
                    v:{ 
                        v:obj.totalSalesPlanCountSum,
                        ht:0
                    },
                },
                {
                    r:2,
                    c:5,
                    v:{ 
                        v:obj.salesUnitPriceSum,
                        ht:0
                    },
                },
                {
                    r:3,
                    c:5,
                    v:{ 
                        v:obj.totalRevenueSum,
                        ht:0
                    },
                },
                {
                    r:4,
                    c:5,
                    v:{ 
                        v:obj.costSum,
                        ht:0
                    },
                },
                {
                    r:5,
                    c:5,
                    v:{ 
                        v:obj.logisticsExpensesSum,
                        ht:0
                    },
                },
                {
                    r:6,
                    c:5,
                    v:{ 
                        v:obj.tariffSum,
                        ht:0
                    },
                },
                {
                    r:7,
                    c:5,
                    v:{ 
                        v:obj.operatingExpensesAndOtherSum,
                        ht:0
                    },
                },
                {
                    r:8,
                    c:5,
                    v:{ 
                        v:obj.totalCostSum,
                        ht:0
                    },
                },
                {
                    r:9,
                    c:5,
                    v:{ 
                        v:obj.monthlyDataChangeSum,
                        ht:0
                    },
                },
                {
                    r:10,
                    c:5,
                    v:{ 
                        v:obj.profitSum,
                        ht:0
                    },
                },
                {
                    r:11,
                    c:5,
                    v:{ 
                        v:obj.profitMarginSum+'%',
                        ht:0
                    },
                },
            )
            this.demo()
        },
        getExcelData(str){
            let arr = str.substr(0,7).split("-")
            let date;
            if(arr[1].substr(0,1)==0){
                date = arr[0]+'年'+arr[1].substr(1,2)+'月'
            }else{
                date = arr[0]+'年'+arr[1]+'月'
            }
            return date

        },
    },
    beforeDestroy(){
        window.luckysheet.exitEditMode();
        window.luckysheet.destroy();
        const scrollview = this.$refs['scrollview']
        // 移除监听
        scrollview.removeEventListener('scroll', this.scrollChange, true)
    },
}
</script>
<style lang="scss" scoped>
.order{
    min-height:calc(100vh - 100px);
    overflow: hidden;
    // background: pink;
    position: relative;
    #luckysheet{
        margin:0px;
        padding:0px;
        position:absolute;
        width:98%;
        box-sizing: border-box;
        left: 0px;
        top: 82px;
        bottom:0px;
        height: 88%;
    }
    .luck-btn{
        width: 100%;
        background: #fff;
        padding: 6px;
        box-sizing: border-box;
        margin-top: 50px;
        // align-items: center;
        p{
            font-size: 14px;
            color: #333;
            font-weight: bold;
            margin-right: 10px;
        }
        span{
            font-size: 12px;
            
        }
    }

}
</style>